<script lang="ts">
	// Most of your app wide CSS should be put in this file
	import '../app.css';

	import { page } from '$app/state';
	import { particlesInit } from '$lib/shared/ui/particles';
	import { loadFull } from 'tsparticles';
	import { pageTransitioning } from '$lib/shared/lib/stores';
	import { fade } from 'svelte/transition';
	import { initializeAnalytics, trackPageView } from '$lib/shared/lib/analytics';
	import { browser } from '$app/environment';
	import ToastGroupMount from '$components/ToastGroupMount.svelte';
	import DefaultLayout from '$layouts/DefaultLayout.svelte';

	let { data, children } = $props();

	let overlay = $derived(
		(page.route.id &&
			(page.route.id.startsWith('/admin/[tag]/overlay') || page.route.id.startsWith('/o/'))) ||
			!page.route.id
	);

	$effect(() => {
		if (page) {
			// Timeout lets the transition actually work
			setTimeout(() => {
				pageTransitioning.set(false);
			}, 0);

			// Initialize GA (idempotent) and track the page view together so a
			// page view is never sent before window.gtag exists. Skipped on overlay
			// routes (embedded widgets that must not load analytics).
			if (browser && !overlay && page.url) {
				initializeAnalytics();
				trackPageView(page.url);
			}
		}
	});

	void particlesInit(async (engine) => {
		await loadFull(engine);
	});
</script>

<ToastGroupMount />

{#if $pageTransitioning}
	<div transition:fade={{ duration: 200 }} class="fixed inset-0 z-9999 bg-surface-50-950"></div>
{/if}

<div class="relative z-10">
	{#if page.route.id === "/"}
		<DefaultLayout user={data.user}>
			{@render children?.()}
		</DefaultLayout>
	{:else}
		{@render children?.()}
	{/if}
</div>
